<template>
  <div class="container-info-geo-env" v-if="!loading">
    <div>
      <h4>Miljöer</h4>
      <v-checkbox
        dense
        hide-details
        v-for="env in envOptions"
        v-model="env.selected"
        :label="env.name"
        :key="env.id"
        @change="(val) => onChangeEnv({ id: env.id, include: val })"
      />
    </div>
    <div>
      <h4>Geografiska områden</h4>
      <v-checkbox
        dense
        hide-details
        v-for="geo in geoOptions.slice(0, 7)"
        v-model="geo.selected"
        :label="geo.name"
        :key="geo.id"
        @change="(val) => onChangeGeo({ id: geo.id, include: val })"
      />
    </div>
    <div>
      <div class="mt-7"></div>
      <v-checkbox
        dense
        hide-details
        v-for="geo in geoOptions.slice(7)"
        v-model="geo.selected"
        :label="geo.name"
        :key="geo.id"
        @change="(val) => onChangeGeo({ id: geo.id, include: val })"
      />
    </div>
  </div>
</template>

<script>
import { GeoAreas, LifeEnv } from '@/assets/data/options'

export default {
  name: 'InfoEnvGeo',
  props: {
    environments: {
      type: Array,
    },
    geo: {
      type: Array,
    },
    loading: { type: Boolean },
  },
  computed: {
    selectedEnvIDs() {
      return this.environments.map((e) => e.env_id)
    },
    selectedGeoIDs() {
      return this.geo.map((g) => g.geo_id)
    },
    geoOptions() {
      return GeoAreas.map(({ id, name }) => {
        return { id, name, selected: this.selectedGeoIDs.includes(id) }
      })
    },
    envOptions() {
      return LifeEnv.map(({ id, name }) => {
        return { id, name, selected: this.selectedEnvIDs.includes(id) }
      })
    },
  },
  methods: {
    onChangeEnv({ id, include }) {
      const envIDs = include
        ? [...this.selectedEnvIDs, id]
        : [...this.selectedEnvIDs.filter((envId) => envId !== id)]
      const payload = { environments: envIDs.map((id) => ({ env_id: id })) }
      this.$emit('change', payload)
    },
    onChangeGeo({ id, include }) {
      const geoIDs = include
        ? [...this.selectedGeoIDs, id]
        : [...this.selectedGeoIDs.filter((geoId) => geoId !== id)]
      const payload = { geoAreas: geoIDs.map((id) => ({ geo_id: id })) }
      this.$emit('change', payload)
    },
  },
}
</script>

<style lang="less" scoped>
.container-info-geo-env {
  display: flex;
  gap: 60px;
}
</style>
